import { TextInput } from "@/components/admin/text-input";

import { useContactMandatory } from "./useContactMandatory";

/**
 * Almikia Epic EC2a: Nombre(s), Apellido paterno and Apellido materno, the three mandatory
 * name fields (replace the old first_name / last_name pair).
 */
export const ContactNameInputs = () => {
  const { validate } = useContactMandatory();
  return (
    <>
      <TextInput
        source="first_name"
        validate={validate("first_name")}
        helperText={false}
      />
      <TextInput
        source="last_name"
        validate={validate("last_name")}
        helperText={false}
      />
      <TextInput
        source="second_last_name"
        validate={validate("second_last_name")}
        helperText={false}
      />
    </>
  );
};
